// @flow
import * as React from 'react';
import classNames from 'classnames';

// Components
import { TextareaAutosize } from '@material-ui/core';
import BaseTextField from '@material-ui/core/TextField';

// Styles
import styles from './TextAreaField.scss';

const VARIANT = {
  STANDARD: 'standard',
  FILLED: 'filled',
  OUTLINED: 'outlined',
};

export type PropTypes = {
  children?: React.Node,
  classes?: {
    root?: string
  },
  className?: string,
  color?: ColorType,
  disabled?: boolean,
  fullWidth?: boolean,
  loaded?: boolean,
  onClick?: (SyntheticEvent<HTMLButtonElement>) => ?void,
  to?: string,
  type?: string,
  outlined?: boolean,
  variant?: typeof VARIANT.FILLED | typeof VARIANT.OUTLINED | typeof VARIANT.STANDARD
};

const TextAreaField = ({
  children,
  classes = {},
  className,
  variant = VARIANT.STANDARD,
  outlined,
  ...props
}: PropTypes): React.Element<BaseTextField | InputBase> => {

  if (outlined) {
    return (
      <TextareaAutosize
        classes={classes}
        className={classNames(
          className,
          styles.Root
        )}
        maxRows={10}
        minRows={10}
        {...props}
      />
    );
  };

  return (
    <BaseTextField
      classes={classes}
      className={classNames(
        className,
        styles.Root,
        {
          [styles.RootVariantStandart]: variant === VARIANT.CONTAINED,
          [styles.RootVariantFilled]: variant === VARIANT.TEXT,
          [styles.RootVariantOutlined]: variant === VARIANT.OUTLINED,
        }
      )}
      variant={variant}
      {...props}
    />
  );
};

export default TextAreaField;
